import React from 'react';
import { IconCircleCheck, IconCircle } from '../../components/ui-kit/icons';
import { Tooltip, OverlayTrigger } from '../ui-kit';

// This component shows an colored circle indicating the availability status
// of a Duty Transaction Candidate. This is used in the candidate select
// table for Duty Requests.
const AvailabilityIcon = props => {
  const hoursAvailable = props.group.available_time / 3600;
  let color = 'orange';
  if (props.candidate.length <= props.group.available_time) color = '#00bb00';
  if (props.group.available_time <= 0) color = 'red';
  if (props.candidate.assigned_functions.length > 0) color = 'blue';

  const style = { color };

  const icon =
    props.candidate.length <= props.group.available_time ? (
      <IconCircleCheck style={style} />
    ) : (
      <IconCircle style={style} />
    );

  return (
    <OverlayTrigger
      placement="right"
      overlay={
        <Tooltip id={`tooltip-available-time-${props.candidate.id}`}>
          {I18n.t('schedules.exchanges.duty_exchange.candidates.available_for', {
            hours_available: hoursAvailable
          })}
        </Tooltip>
      }
    >
      {icon}
    </OverlayTrigger>
  );
};

export default AvailabilityIcon;
